import { useQuery } from "react-query";
import axios from "axios";
import Config from "../Config";
import { useSelector } from "react-redux";

const useOrders = () => {
    const user = useSelector((state) => state.UserReducer.user);
    
    return useQuery(
        ['orders', user?.token],
        async () => {
            // console.log(`Fetching orders for user: ${user?.token}`);
            const { data } = await axios.get(`${Config.apiUrl}/orders/my-orders`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            // console.log('Orders data:', data);
            return data.data || data;
        },
        {
            // The query will only run if we have a token
            enabled: !!user?.token,
            staleTime: 1000 * 60 * 5, // 5 minutes
            refetchOnWindowFocus: false,
        }
    );
};

export default useOrders;
